import React from 'react';
import Typography from '../../../shared/components/Typography/Typography';

const QuoteHeader = ({
  title,
  subtitle,
  primaryAction,
  secondaryAction,
  extraActions = [],
  saving = false,
}) => (
  <header className="quote-header">
    <div>
      <Typography variant="h4">{title}</Typography>
      {subtitle && (
        <Typography variant="body2" color="textSecondary">
          {subtitle}
        </Typography>
      )}
    </div>

    <div className="quote-header-actions">
      {primaryAction && (
        <button
          className="basic-button active"
          type="button"
          onClick={primaryAction.onClick}
          disabled={primaryAction.disabled || saving}
        >
          {saving && primaryAction.savingLabel ? primaryAction.savingLabel : primaryAction.label}
        </button>
      )}
      {secondaryAction && (
        <button
          className="basic-button"
          type="button"
          onClick={secondaryAction.onClick}
          disabled={secondaryAction.disabled || saving}
        >
          {secondaryAction.label}
        </button>
      )}
      {extraActions.map((action) => (
        <button
          className="basic-button"
          type="button"
          key={action.label}
          onClick={action.onClick}
          disabled={action.disabled || saving}
        >
          {action.label}
        </button>
      ))}
    </div>
  </header>
);

export default QuoteHeader;
